import React from 'react';

interface TikTokPreviewProps {
  url: string;
}

const TikTokPreview: React.FC<TikTokPreviewProps> = ({ url }) => {
  // Function to extract TikTok username from URL
  const extractTikTokUsername = (url: string) => {
    const match = url.match(/tiktok\.com\/@([^/?]+)/);
    return match ? match[1] : null;
  };

  const username = extractTikTokUsername(url);

  if (!username) {
    return (
      <a 
        href={url} 
        target="_blank" 
        rel="noopener noreferrer"
        className="text-blue-500 hover:text-blue-600 flex items-center gap-2"
      >
        <span className="font-bold">TikTok</span>
        {url}
      </a>
    );
  }

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="block my-2 max-w-[500px] rounded-lg border border-gray-200 hover:bg-gray-50 transition-all duration-200 overflow-hidden bg-white"
    >
      <div className="p-4 flex items-center gap-4">
        <div className="bg-black text-white px-3 py-2 rounded-lg font-bold text-xl">
          TT
        </div>
        <div className="flex-grow">
          <div className="font-semibold text-gray-900 text-lg">@{username}</div>
          <div className="text-sm text-gray-500">TikTok Profile</div>
        </div>
        <div className="text-gray-400">→</div>
      </div>
    </a>
  );
};

export default TikTokPreview;
